import './infiniteList.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Scrollable from '../Scrollable';
import RequestManager from "../../requests/RequestManager";
import LevelTask from "../../requests/tasks/cms/LevelTask";
import Grid from '../GridNew';
import Parser from "../../utils/Parser";
import RibbonCategories from '../RibbonNew/RibbonTypes/RibbonCategories';
import GeneralRibbonUtils from '../RibbonNew/GeneralRibbonUtils';
import {withRouter} from 'react-router-dom';
import store from '../../store';
import { playFullMedia } from '../../actions/playmedia';
import LayersControl from '../../utils/LayersControl';
import { LIVE_PLAY_FROM_HOME } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';
import PlayerStreamingUtils from 'src/utils/PlayerStreamingUtils';
import asyncPinObserver from 'src/AAF/Pin/AsyncPinObserver';
import {removeDynamicFocus} from "../Focus/utils";

class InfiniteList extends Component {
  constructor(props) {
    super(props);

    this.level = this.props.level;
    this.state = { url: '', force: false};
    this.ribbonsCategories = this.props.ribbonsCategories;
  }

  getAllParametersFromQs(qs){
    let res;
    let params = {};

    if (qs){
      res = qs.split('&');

      res.forEach((item, index) => {
        let par = item.split('=');

        if (par[0] && par[1]){
          params[par[0]] = par[1];
        }
      })
    }

    return params;
  }

  getRequest(qs) {
    if (qs === undefined){
      return {};
    }

    let result = {};
    let qsArray = qs.split('?');

    if (qsArray[0]) {
      result.uri = qsArray[0];
    }

    if (qsArray[1]) {
      result.params = this.getAllParametersFromQs(qsArray[1]);
    }
    return result;
  }

  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  componentDidMount(){
    this.newGridList(this.level);
  }

  componentWillReceiveProps(nextProps){
    (nextProps.level !== this.props.level) ? this.newGridList(nextProps.level) : '';
  }

  newGridList(actualLevel){
    setTimeout(function() { window.SpatialNavigation.focus('.channels-container .focusable'); }, 900);
    removeDynamicFocus();
    const levelTask = new LevelTask(actualLevel);
    let promiseLevel = RequestManager.addRequest(levelTask);

    promiseLevel.then((res) => {
      let modules = Parser.parserModules(res);

      //Buscar la url para 3er nivel
      const statusSuccess = res.status === 0 || res.status === "0" || res.status === "200" || res.status === 200

      if (statusSuccess) {
        let components =
          (modules && modules.module && modules.module[0].components && modules.module[0].components.component) || (modules && modules[0].components && modules[0].components.component);

        for(let component = 0; component < components.length; component++){
          if (components[component].name === 'carrousel') {
            let url = components[component].properties.url;
            if(url){
              url = url.replace('quantity=40', 'quantity=12')

              this.setState({ url })

              this.requets = this.getRequest(url);
            }
          }
        }

        // for (var component of components){
        //   console.log("🚀 ~ InfiniteList-NEW ~ promiseLevel.then ~ component:", component)
        //   if (component.name === 'carrousel') {
        //     let url = component.properties.url;
        //     if(url){
        //       url = url.replace('quantity=40', 'quantity=12')

        //       this.setState({ url })

        //       this.requets = this.getRequest(url);
        //     }
        //   }
        // }
      } else if (res.status == "1" && res.errors && res.errors.error && res.errors.error["0"]) {
        console.error(res.errors.code + ': ' + res.errors.error["0"]);
      }
    });
  }

  clickHandler(data) {
    let { group_id = null, live_enabled = '' } = data;
    live_enabled = parseInt(live_enabled);
    if(!group_id){
      group_id = data.id;
    }
    const playerStreamingUtils = new PlayerStreamingUtils();
    if (live_enabled === 1 && !playerStreamingUtils.canPlayChannel(group_id) ) {
      asyncPinObserver.fire('awaitpbiInfo');
      playerStreamingUtils.checkSusc(null, group_id, () => { }, data).then(() => {
        asyncPinObserver.fire('pbiInfocomplete');
      });
    } else if (live_enabled === 1 && group_id) {
      store.dispatch(playFullMedia({
        playerstate: 'PLAYING',
        source: {
          videoid: group_id
        },
        size:{
          top:0,
          left:0,
          width: 1280,
          height: 720,
        },
        ispreview: false,
        islive: true,
        ispip: false,
        showEpg: false,
        filterTV: false,
        event: null,
        playFromCard: true,
        /**
         * Considerar reemplazar la bandera de arriba con la bandera de abajo (quitar playFromCard y dejar playLiveFrom)
         */
        playLiveFrom: LIVE_PLAY_FROM_HOME
      }));
      LayersControl.hideUX();
    }
  }

  render() {
    let visibleMenuItems = null;
    if(this.props.ribbonsCategories){
      const visibleNumber = GeneralRibbonUtils.getVisibleNumber({type: this.props.ribbonsCategories.type, visibleNumber: 20});
      visibleMenuItems = JSON.parse(JSON.stringify(GeneralRibbonUtils.getVisibleItems(this.props.ribbonsCategories.items, visibleNumber, 0)));
      if (visibleMenuItems){
        visibleMenuItems = visibleMenuItems.map((menu) => {
          if (menu && menu.item) {
            if(menu.item.href.includes('mundial')) {
              menu.item.dataSnUp = '#aaf_menu-container-center .active.focusable'
            } else {
              menu.item.dataSnUp = '.btn-filter.focusable'
              menu.item.dataSnDown = ''
            }
          }
          return menu;
        });
      }
    }
    return (
      <Scrollable height={'600px'}>
        {this.props.buttonFilter ? <div className="container-button-filter">
          <div className={'horizontal-bar'}></div>
          {this.props.children}
        </div> : null}
        <div className="container-infinite-list">
          {visibleMenuItems && <RibbonCategories
            visibleItems = {visibleMenuItems}
            focusHandler = {this.props.focusHandler}
            history={this.props.history}
            code={this.props.code}
          />}
          <Grid
            setChargeList={this.props.setChargeList}
            orderFilter={this.props.order}
            user={this.props.user}
            rows={3}
            cols={4}
            request={this.getRequest(this.state.url)}
            width='1250px'
            height='500px'
            focusHandler={this.props.focusHandler}
            setMetricsEvent={this.props.setMetricsEvent}
            onClickHandler={this.clickHandler}
          />
        </div>
      </Scrollable>
    )
  }
}

InfiniteList.propTypes = {
  level: PropTypes.string.isRequired,
  user: PropTypes.object,
  ribbonsCategories: PropTypes.array
};

InfiniteList.defaultProps = {
    level: '',
    user: {},
    ribbonsCategories: []
};

export default withRouter(InfiniteList);



// WEBPACK FOOTER //
// ./src/components/InfiniteListNew/index.jsx